// Smooth-scrolls an element to the top of the screen, but BELOW the sticky site header —
// a plain scrollIntoView({block: 'start'}) tucks the element's top edge behind it.
export function scrollBelowHeader(el, gap = 16) {
    if (!el) return
    const header = document.querySelector('header')
    const headerH = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0
    el.style.scrollMarginTop = `${headerH + gap}px`
    el.scrollIntoView({behavior: 'smooth', block: 'start'})
}
